import React from "react";
import { useLayoutStyles } from "./index.styles";
import { Menu } from "../../Components/Menu";
import { Outlet } from "react-router-dom";
import { Divider, Toaster } from "@fluentui/react-components";
import { useId } from "@fluentui/react-hooks";
import { useAppToast } from "hooks/Toast/useAppToast";

export default function Layout() {
  const useStyles = useLayoutStyles();
  const { appToaster } = useAppToast();
  return (
    <div className={useStyles.container}>
      <Menu />
      <Divider appearance="subtle" />
      {appToaster()}
      <Outlet />
    </div>
  );
}
